import { useState } from "react";
import { toast } from "sonner";
import { Switch } from "@/components/ui/switch";
import { useAuth } from "@/context/AuthContext";
import { api, apiError } from "@/lib/api";

export const EmailPrefs = () => {
  const { user, setUser } = useAuth();
  const [busy, setBusy] = useState(false);
  const toggle = (key, label) => async (value) => {
    setBusy(true);
    try {
      const { data } = await api.put("/me/email-prefs", { [key]: value });
      setUser({ ...user, ...data });
      toast.success(`${label} emails ${value ? "on" : "off"}`);
    } catch (e) { toast.error(apiError(e)); } finally { setBusy(false); }
  };
  return (
    <section className="mt-14 border-t border-border pt-8" data-testid="email-prefs-section">
      <h2 className="text-lg font-semibold">Email notifications</h2>
      <PrefRow id="email-connections" label="Email me when someone asks to connect or accepts my request" checked={user.email_connections !== false} disabled={busy} onChange={toggle("connections", "Connection")} />
      <PrefRow id="email-trip-calls" label="Email me when a trip group call starts, is scheduled, or is about to begin" checked={user.email_trip_calls !== false} disabled={busy} onChange={toggle("trip_calls", "Trip call")} />
    </section>
  );
};

const PrefRow = ({ id, label, checked, disabled, onChange }) => (
  <div className="mt-4 flex items-center justify-between gap-6">
    <label htmlFor={id} className="text-sm text-foreground/80">{label}</label>
    <Switch id={id} checked={checked} disabled={disabled} onCheckedChange={onChange} data-testid={`${id}-switch`} />
  </div>
);
